import {
  AGREEMENTS,
  KNM_EPGU_NOTIFICATION,
  KNM_HISTORY,
  KNM_NOTIFICATION,
  KNM_SIGN_INFO,
  PM_ACT,
  PM_COLLABORATING,
  PM_EVENTS,
  PM_EVENT_SUBJECT,
  PM_INFO,
  PM_INSPECTORS,
  PM_OBJECTS,
  PM_REASONS,
  PM_REJECT,
  PM_RESULT_OF_INSPECTION,
  PM_SUBJECT,
  PM_WARNING,
  REPEAT_PASSPORTS,
} from 'CorePackage/MainModule/routes/routes';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { insertItemAfterIdInPlace } from 'KnmErknmPackage/KnmErknmMenuModule/constants/insertItemAfterIdInPlace';

import { PmMenuItemsIdsEnum } from '../enums/PmMenuItemsIdsEnum';
import { IKnmPmMenuItem } from '../interfaces/IKnmPmMenuItem';

export const basicPmMenuItems = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): IKnmPmMenuItem[] => {
  const agreementsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM,
  )?.value;

  const repeatPassportsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM,
  )?.value;

  const isEnablePaperlessPassportDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  const isEnableAgreements =
    Boolean(agreementsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM);
  const isEnablePrescriptionCheck =
    Boolean(repeatPassportsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM);

  const items = [
    {
      id: PmMenuItemsIdsEnum.PM_INFO,
      route: `#${PM_INFO}`,
      title: 'Сведения о профилактическом мероприятии',
    },
    {
      id: PmMenuItemsIdsEnum.PM_WARNING,
      route: `#${PM_WARNING}`,
      title: 'Сведения о содержании',
    },
    {
      id: PmMenuItemsIdsEnum.PM_REASONS,
      route: `#${PM_REASONS}`,
      title: 'Основания проведения',
    },
    {
      id: PmMenuItemsIdsEnum.PM_OBJECTS,
      route: `#${PM_OBJECTS}`,
      title: 'Сведения об объектах контроля',
    },
    {
      id: PmMenuItemsIdsEnum.PM_EVENTS,
      route: `#${PM_EVENTS}`,
      title: 'Перечень действий',
    },
    {
      id: PmMenuItemsIdsEnum.PM_SUBJECT,
      route: `#${PM_SUBJECT}`,
      title: 'Сведения о контролируемом лице',
    },
    {
      id: PmMenuItemsIdsEnum.PM_INSPECTORS,
      route: `#${PM_INSPECTORS}`,
      title: 'Сведения о должностных лицах КНО',
    },
    {
      id: PmMenuItemsIdsEnum.PM_EVENT_SUBJECT,
      route: `#${PM_EVENT_SUBJECT}`,
      title: 'Сведения о предмете профилактического мероприятия',
    },
    {
      id: PmMenuItemsIdsEnum.PM_COLLABORATING_ORGANIZATION,
      route: `#${PM_COLLABORATING}`,
      title: 'Проведение мероприятия в форме совместного (межведомственного) профилактического мероприятия',
    },
    {
      id: PmMenuItemsIdsEnum.PM_NOTIFICATION,
      route: `#${KNM_NOTIFICATION}`,
      title: isEnablePaperlessPassportDocument ? 'Уведомление о решении' : 'Информация об уведомлении',
    },
    {
      id: PmMenuItemsIdsEnum.PM_REJECT,
      route: `#${PM_REJECT}`,
      title: 'Информация о несогласии',
    },
    {
      id: PmMenuItemsIdsEnum.PM_ACT,
      route: `#${PM_ACT}`,
      title: 'Сведения об акте',
    },
    {
      id: PmMenuItemsIdsEnum.PM_RESULT_OF_INSPECTION,
      route: `#${PM_RESULT_OF_INSPECTION}`,
      title: 'Результаты мероприятия',
    },
    {
      id: PmMenuItemsIdsEnum.PM_SIGN_INFO,
      route: `#${KNM_SIGN_INFO}`,
      title: 'Сведения о подписании',
    },
    {
      id: PmMenuItemsIdsEnum.PM_EPGU_NOTIFICATION,
      route: `#${KNM_EPGU_NOTIFICATION}`,
      title: 'Сведения об информировании контролируемого лица в ЕПГУ',
    },
    {
      id: PmMenuItemsIdsEnum.PM_HISTORY,
      route: `#${KNM_HISTORY}`,
      title: 'История изменений',
    },
  ];

  if (isEnableAgreements) {
    insertItemAfterIdInPlace<IKnmPmMenuItem>(items, PmMenuItemsIdsEnum.PM_RESULT_OF_INSPECTION, {
      id: PmMenuItemsIdsEnum.PM_AGREEMENTS,
      route: `#${AGREEMENTS}`,
      title: 'Сведения о соглашениях',
    });
  }

  if (isEnablePrescriptionCheck) {
    insertItemAfterIdInPlace<IKnmPmMenuItem>(items, PmMenuItemsIdsEnum.PM_EPGU_NOTIFICATION, {
      id: PmMenuItemsIdsEnum.KNM_REPEAT_PASSPORTS,
      route: `#${REPEAT_PASSPORTS}`,
      title: 'Перечень повторных мероприятий',
    });
  }

  return items;
};
